//src/Components/EmojiPicker/contexts.ts
import { createContext } from 'react';
import { EmojiData, IEmojiPreviewRef } from '.';

export const PreviewEmojiContext = createContext<{
  setPreview: (emoji?: EmojiData) => void;
  preview?: EmojiData;
  emojiPreviewRef: React.RefObject<IEmojiPreviewRef>;
}>({} as any);

export const SelectEmojiContext = createContext<{
  selectEmoji: (e: EmojiData) => void;
}>({} as any);
